import React from 'react';

interface tickProps {
  colorString?: string;
  width?: number;
  height?: number;
}

export const UpTick: React.FC<tickProps> = ({
  colorString = '',
  width = '13',
  height = '7',
}): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0455 6.93311C13.0626 6.93311 13.3073 6.35906 12.5832 5.64207L7.15459 0.266744C6.79249 -0.0918036 6.20017 -0.0866241 5.84329 0.266744L0.414588 5.64207C-0.305513 6.35509 -0.0631675 6.93311 0.952287 6.93311H12.0455Z"
        fill={colorString ? colorString : '#56FFA9'}
      />
    </svg>
  );
};

export const DownTick: React.FC<tickProps> = ({
  colorString = '',
  width = '13',
  height = '7',
}): JSX.Element => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0455 0C13.0626 0 13.3073 0.57404 12.5832 1.29104L7.15459 6.66636C6.79249 7.02491 6.20017 7.01973 5.84329 6.66636L0.414588 1.29104C-0.305513 0.578017 -0.0631675 0 0.952287 0H12.0455Z"
        fill={colorString ? colorString : '#FF6D6D'}
      />
    </svg>
  );
};
